import { LocationTypeCode } from "../../../types/LocationTypeCode";
import { LocationOption } from "../../../app/consts";
import { ILocation } from "../../../types/ILocation";

export function locationFilter(
   location: ILocation,
   locationValue: LocationOption,
): boolean {
   const locationType = location.locationType;
   switch (locationValue) {
      // SCREDP-42: remove hardcoded codes and use the specified boolean fields
      case LocationOption.MOBILE_DRIVE:
         return locationType.isMobile;
      case LocationOption.DONATION_CENTER:
         return locationType.isFixedSite
      case LocationOption.ALL:
         return true;
      default:
         console.error("Invalid location filter type");
         return false;
   }
}
